import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    maxHeight: '100%',
  },
  header: {
    flexShrink: 0,
  },
  text: {
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  row: {
    display: 'flex',
    gap: 12,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: 0,
    },
  },
  error: {
    minHeight: 20,
    textAlign: 'center',
    color: 'red',
    marginBottom: theme.spacing(1),
    fontSize: 13,
    flexShrink: 0,
  },
  success: {
    minHeight: 20,
    textAlign: 'center',
    color: theme.palette.success.main,
    marginBottom: theme.spacing(1),
    fontSize: 13,
    flexShrink: 0,
  },
  submit: {
    color: 'white',
    background: theme.palette.primary.main,
    height: 48,
    marginBottom: 8,
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
  secondary: {
    height: 48,
    marginBottom: 8,
  },
  link: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    display: 'block',
    marginTop: 4,
    fontSize: 14,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: 2,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 13,
    color: '#646464',
    marginBottom: 12,
    textAlign: 'center',
  },
  stepper: {
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    marginBottom: 8,
  },
  stepDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    background: '#D8D8DA',
  },
  stepDotActive: {
    background: theme.palette.primary.main,
  },
  stepLabel: {
    fontSize: 13,
    fontWeight: 500,
    color: '#646464',
    marginBottom: 8,
    textAlign: 'center',
  },
  formScroll: {
    flex: 1,
    minHeight: 0,
    maxHeight: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: 6,
    marginBottom: 8,
    WebkitOverflowScrolling: 'touch',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#C4C4C4',
      borderRadius: 8,
    },
  },
  actions: {
    flexShrink: 0,
    paddingTop: 4,
    borderTop: '1px solid #E9E9E9',
    background: '#fff',
  },
}));

export default useStyles;
